import React, { useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import { MediaQueries } from 'src/util/constants';

import './ScrollLinksNavList.scss';

export enum ListOrientation {
    Horizontal = 'horizontal',
    Vertical = 'vertical',
}

export interface LinkConfig {
    scrollTargetId: string;
    text: string;
}

interface ScrollingLinksNavListProps {
    links: Array<LinkConfig>;
    orientation?: ListOrientation;
}

export default function ScrollLinksNavList({ links, orientation }: ScrollingLinksNavListProps) {
    const isTablet = useMediaQuery(MediaQueries.Tablet);
    const isPhone = useMediaQuery(MediaQueries.Phone);

    const [activeLinkIndex, setActiveLinkIndex] = useState(0);

    const getNavClasses = () => {
        const baseClass = 'scrolling-links-nav-list';
        return `${baseClass} ${baseClass}--${orientation}`;
    };

    const getNavItemClasses = (i: number) => {
        const baseClass = 'scrolling-links-nav-list__item';
        return `${baseClass} ${activeLinkIndex === i ? `${baseClass}--active` : ''}`;
    };

    const scrollToTarget = (targetId: string, i?: number) => {
        const target = document.getElementById(targetId);

        if (target) {
            if (isPhone || isTablet) {
                target.scrollIntoView({ block: 'start', inline: 'nearest' });
            } else {
                target.scrollIntoView(true);
            }
        }

        if (i !== undefined) setActiveLinkIndex(i);
    };

    const onSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        e.preventDefault();
        scrollToTarget(e.currentTarget.value);
    };

    const listNav = (
        <nav className={getNavClasses()}>
            <ul className="scrolling-links-nav-list__list">
                {links.map((link, i) => (
                    <li className={getNavItemClasses(i)} key={i}>
                        <a
                            className="scrolling-links-nav-list__link"
                            href={'#{ link.scrollTargetId }'}
                            onClick={(e) => {
                                e.preventDefault();
                                scrollToTarget(link.scrollTargetId, i);
                            }}
                        >
                            {link.text}
                        </a>
                    </li>
                ))}
            </ul>
        </nav>
    );

    const selectNav = (
        <nav className="scrolling-links-nav-list__select-wrapper">
            <label htmlFor="nav-list" className="scrolling-links-nav-list__select-label">
                Section:
            </label>
            <select id="nav-list" className="scrolling-links-nav-list__select" onChange={onSelectChange}>
                {links.map((link, i) => (
                    <option key={i} value={link.scrollTargetId}>
                        {link.text}
                    </option>
                ))}
            </select>
        </nav>
    );

    return isTablet || isPhone ? selectNav : listNav;
}

ScrollLinksNavList.defaultProps = {
    links: [],
    orientation: ListOrientation.Horizontal,
};
